import { ThemeProvider } from "@repo/ui";
import React from "react";
import { ApiClientProvider } from "../contexts/ApiContext";
import { AuthProvider } from "../contexts/AuthContext";
import { ExperimentsProvider } from "../contexts/experiments";
import { DatabaseProvider } from "../db/DatabaseProvider";

export const Providers = ({ children }: { children: React.ReactNode }) => {
	return (
		<ThemeProvider>
			<ExperimentsProvider>
				<ApiClientProvider>
					<DatabaseProvider>
						<AuthProvider>{children}</AuthProvider>
					</DatabaseProvider>
				</ApiClientProvider>
			</ExperimentsProvider>
		</ThemeProvider>
	);
};
